import { Fragment } from "react";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
// import ProjectSection from "../../components/ProjectSection/ProjectSection";
// import ProjectForm from "../../components/ProjectSection/Projectform";
/*import TestimonialSection from '../../components/TestimonialSection/TestimonialSection';*/
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Logo from "../../images/logo-2.svg";
import Phone from "../../images/telephone.svg";
import career from "../../images/project/4.webp";
// import CursorMaus from '../../components/CursorMaus/CursorMaus';
import LenisSmoothScroll from "../../components/lenissmoothscroll/LenisSmoothScroll";
import CareerForm from "./CareerForm.jsx";
import '../../css/career.css';
const ProjectPage = () => {
  return (
    <Fragment>
      <Navbar Logo={Logo} hclass={"wpo-site-header s3"} telephone={Phone} />

      <PageTitle pageTitle={"Careers"} pagesub={"Careers"} />
      <div className="container">
        <div className="row d-flex mt-5">
          <div className="col-lg-6 col-md-12 col-sm-12 ">
            {/* <ProjectSection hclass={"project-section"} /> */}
            <div className="career-img">
              <img src={career} alt="Career opportunities" />
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 ">
            <CareerForm />
          </div>
        </div>
      </div>
      {/*<TestimonialSection />*/}

      <Footer />
      <Scrollbar />
      {/* <CursorMaus /> */}
      <LenisSmoothScroll />
    </Fragment>
  );
};
export default ProjectPage;
